import React from "react";
import { Button } from "../../ui-library/Button/Button";
import styles from "./FileUploadTermsModal.module.css";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "../../ui-library/Dialog";

export interface FileUploadTermsModalProps {
  open: boolean;
  onAccept: () => void;
  onCancel: () => void;
}

export const FileUploadTermsModal: React.FC<FileUploadTermsModalProps> = ({
  open,
  onAccept,
  onCancel,
}) => {
  return (
    <Dialog open={open} onClose={onCancel} size="small">
      <DialogHeader title="Terms and Conditions" />
      <DialogContent>
        <p>
          Before you upload files, please make sure you have read and are
          abiding by your company's Terms and Conditions.
        </p>
        <p>
          <a
            href="/terms-and-conditions"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.LinkTermsConditionsModal}
          >
            Terms & Conditions
          </a>
        </p>
      </DialogContent>
      <DialogFooter>
        <Button onClick={onCancel} variant="transparent">
          Cancel
        </Button>
        <Button onClick={onAccept}>OK</Button>
      </DialogFooter>
    </Dialog>
  );
};
